/* eslint-disable @typescript-eslint/no-explicit-any */
import { takeLatest, put, call, select } from 'redux-saga/effects';
import { SagaIterator } from 'redux-saga';
import { AxiosResponse } from 'axios';
import { processRequestError } from '../error/actions';
import {
  GET_REFUNDS_REQUEST,
  CREATE_REFUND_REQUEST,
  RETRIEVE_REFUND_REQUEST,
  UPLOAD_ATTACHMENTS_REQUEST,
} from './types';
import {
  getRefundsAction,
  createRefundAction,
  uploadAttachmentsAction,
  refundDetailsAction,
} from './actions';
import { RefundsApi } from '../../services/Refunds';
import { RootState } from '../../store/store';

// Сага для получения списка возвратов
function* handleGetRefundsSaga(): SagaIterator {
  try {
    const response: AxiosResponse = yield call(RefundsApi.getRefunds);
    yield put(getRefundsAction.success(response.data));
  } catch (error: any) {
    yield put(processRequestError({ error, failAction: getRefundsAction.failure }));
  }
}

// Сага для создания возврата
function* handleCreateRefundSaga(
  action: ReturnType<typeof createRefundAction.request>,
): SagaIterator {
  try {
    const response: AxiosResponse = yield call(RefundsApi.createRefund, action.payload);
    yield put(createRefundAction.success(response.data));
  } catch (error: any) {
    yield put(processRequestError({ error, failAction: createRefundAction.failure }));
  }
}

// Сага для получения конкретного возврата
function* handleRetrieveRefundSaga(
  action: ReturnType<typeof refundDetailsAction.request>,
): SagaIterator {
  try {
    const response: AxiosResponse = yield call(RefundsApi.retrieveRefund, action.payload);
    yield put(refundDetailsAction.success(response.data));
  } catch (error: any) {
    yield put(processRequestError({ error, failAction: refundDetailsAction.failure }));
  }
}

function* handleUploadAttachmentsSaga(
  action: ReturnType<typeof uploadAttachmentsAction.request>,
): SagaIterator {
  try {
    const { files } = action.payload;
    const id = yield select(({ refunds }: RootState) => refunds.uploadId);
    console.log(id, 'id');

    const response: AxiosResponse = yield call(RefundsApi.uploadAttachments, id, files);

    yield put(uploadAttachmentsAction.success(response.data));
  } catch (error: any) {
    yield put(processRequestError({ error, failAction: uploadAttachmentsAction.failure }));
  }
}

// Главная сага для обработки всех экшенов
export function* refundsSaga(): SagaIterator {
  yield takeLatest(GET_REFUNDS_REQUEST, handleGetRefundsSaga);
  yield takeLatest(CREATE_REFUND_REQUEST, handleCreateRefundSaga);
  yield takeLatest(RETRIEVE_REFUND_REQUEST, handleRetrieveRefundSaga);
  yield takeLatest(UPLOAD_ATTACHMENTS_REQUEST, handleUploadAttachmentsSaga);
}
